import React, { useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  // Upload,
  Radio,
  Checkbox,
  Card,
  message,
  Typography,
} from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
  RetweetOutlined,
  FormOutlined,
  BackwardOutlined,
  // UploadOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  CourseTopLevel,
  CourseTopLevelCA,
} from "../../../components/AdminComponents/MenuItems";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import MediaUpload from "./MediaUpload";
const { Option } = Select;
const { Title, Paragraph } = Typography;
const CourseQuizAdd = () => {
  const [form] = Form.useForm();
  const [questions, setQuestions] = useState([
    {
      id: 1,
      type: "single",
      options: ["Option 1", "Option 2"],
      media: null,
    },
  ]);

  // Add new question
  const addQuestion = () => {
    setQuestions([
      ...questions,
      {
        id: questions.length + 1,
        type: "single",
        options: ["Option 1"],
        media: null,
      },
    ]);
  };

  // Add option to a question
  const addOption = (qIndex) => {
    const newQs = [...questions];
    newQs[qIndex].options.push(`Option ${newQs[qIndex].options.length + 1}`);
    setQuestions(newQs);
  };

  // Remove option
  const removeOption = (qIndex, optIndex) => {
    const newQs = [...questions];
    newQs[qIndex].options.splice(optIndex, 1);
    setQuestions(newQs);
  };

  // eslint-disable-next-line no-unused-vars
  const handleUpload = (qIndex, file) => {
    const newQs = [...questions];
    newQs[qIndex].media = URL.createObjectURL(file);
    setQuestions(newQs);
    return false; // prevent auto upload
  };

  // eslint-disable-next-line no-unused-vars
  const onFinish = (values) => {
    console.log("Final Quiz Data:", { ...values, questions });
    message.success("Quiz saved successfully!");
  };
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadPercent, setUploadPercent] = useState(0);

  const handleChange = (info) => {
    const file = info.file.originFileObj;
    if (file) {
      setUploading(true);
      setUploadPercent(0);
      setFileList([file]);
      setPreviewUrl(URL.createObjectURL(file));

      // simulate upload progress
      const interval = setInterval(() => {
        setUploadPercent((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            setUploading(false);
            return 100;
          }
          return prev + 10;
        });
      }, 100);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setFileList([]);
    setPreviewUrl(null);
    setUploadPercent(0);
  };

  const modifyFileName = (name) => {
    return name.replace(/_\d+(?=\.)/, "");
  };
  const handleSubmit = (values) => {
    console.log("Submitted Data:", values, { ...values, questions });
  };
  return (
    <WrapperComponent props={wrapperProps}>
      <div
        style={{
          //   background: "#f4f4f4",
          //   width: "100%",
          //   height: remainingViewportHeight(10),
          marginTop: "50px",
          paddingTop: "30px",
        }}
      >
        <Card
          className="shadow-lg rounded-2xl"
          style={{
            width: "95%",
            margin: "10px auto",
            borderRadius: "12px",
            background: "#fbfbfb",
          }}
        >
          <div style={{ paddingLeft: "20px" }}>
            <Title level={4} style={{ letterSpacing: "0.5px" }}>
              Quiz Creation
            </Title>
            <Paragraph type="secondary">
              Add and configure your own quiz with the details below
            </Paragraph>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            style={{ padding: "20px" }}
            initialValues={{ questionType: "single" }}
          >
            {/* Course & Quiz Details */}
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="course"
                  label="Select Course"
                  rules={[
                    { required: true, message: "Please select a course" },
                  ]}
                >
                  <Select placeholder="Choose course">
                    <Option value="course1">Course 1</Option>
                    <Option value="course2">Course 2</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="quizTitle"
                  label="Quiz Title"
                  rules={[
                    { required: true, message: "Please enter quiz title" },
                  ]}
                >
                  <Input placeholder="Enter quiz title" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="quizSku"
                  label="Quiz SKU"
                  rules={[{ required: true, message: "Please enter quiz SKU" }]}
                >
                  <Input placeholder="Enter quiz SKU" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="quizDesc" label="Quiz Description">
                  <Input.TextArea rows={3} placeholder="Enter description" />
                </Form.Item>
              </Col>
            </Row>

            {/* Dynamic Questions */}
            {questions.map((q, qIndex) => (
              <Card
                key={q.id}
                type="inner"
                title={
                  <div
                    style={{
                      // backgroundColor: "#fff", // light blue
                      padding: "4px 12px",
                      borderRadius: "8px",
                      width: "100%", // full width
                      boxSizing: "border-box", // include padding in width
                    }}
                  >
                    {`Question ${q.id}`}
                  </div>
                }
                headStyle={{
                  backgroundColor: "aliceblue",
                  // color: "white",
                  padding: "4px 12px",
                }}
                style={{ marginTop: "20px", borderRadius: "12px" }}
                hoverable
                extra={
                  questions.length > 1 && (
                    <Button
                      danger
                      size="small"
                      onClick={() =>
                        setQuestions(questions.filter((_, i) => i !== qIndex))
                      }
                    >
                      <DeleteOutlined />
                    </Button>
                  )
                }
              >
                <Row gutter={16}>
                  <Col span={16}>
                    <Form.Item
                      name={`question_${q.id}`}
                      label="Question Text"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the question",
                        },
                      ]}
                    >
                      <ReactQuill
                        theme="snow"
                        placeholder="Type your question here..."
                        style={{
                          height: "150px",
                          marginBottom: "40px",
                          fontFamily: "Poppins",
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <MediaUpload
                      fileList={fileList}
                      previewUrl={previewUrl}
                      uploading={uploading}
                      uploadPercent={uploadPercent}
                      handleChange={handleChange}
                      handleClear={handleClear}
                      modifyFileName={modifyFileName}
                    />
                  </Col>
                </Row>

                <Row
                  gutter={16}
                  align="middle"
                  justify="space-between"
                  style={{ marginBottom: 16 }}
                >
                  <Col>
                    <span style={{ marginRight: 12, fontWeight: 500 }}>
                      Question Type:
                    </span>
                    <Radio.Group
                      onChange={(e) => {
                        const newQs = [...questions];
                        newQs[qIndex].type = e.target.value;
                        setQuestions(newQs);
                      }}
                      value={q.type}
                    >
                      <Radio value="single">Single Choice</Radio>
                      <Radio value="multiple">Multiple Choice</Radio>
                    </Radio.Group>
                  </Col>

                  <Col>
                    <Button
                      icon={<PlusOutlined />}
                      onClick={() => addOption(qIndex)}
                      //   size="small"
                      //   type="dashed"
                    >
                      Add Option
                    </Button>
                  </Col>
                </Row>

                {/* Inline Options */}
                <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
                  {q.options.map((opt, optIndex) => (
                    <Col key={optIndex} span={8}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        {q.type === "single" ? (
                          <Radio disabled />
                        ) : (
                          <Checkbox disabled />
                        )}
                        <Input
                          placeholder={`Option ${optIndex + 1}`}
                          // size="small"
                          style={{ flex: 1, marginLeft: 8 }}
                        />
                        {q.options.length > 1 && (
                          <Button
                            danger
                            size="small"
                            type="text"
                            onClick={() => removeOption(qIndex, optIndex)}
                            style={{ marginLeft: 8 }}
                          >
                            X
                          </Button>
                        )}
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card>
            ))}

            {/* Add Question */}
            <Row style={{ marginTop: "20px" }}>
              <Col span={24}>
                <Button
                  type="dashed"
                  size="middle"
                  icon={<PlusOutlined />}
                  onClick={addQuestion}
                  block
                >
                  Add Question
                </Button>
              </Col>
            </Row>

            {/* Submit */}
            <div
              className="group-1-box"
              style={{
                paddingBottom: "0rem",
                paddingLeft: "0px",
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <div>
                <div style={{ display: "inline-block" }}>
                  <Form.Item label=" " colon={false}>
                    <Button
                      type="text"
                      htmlType="button"
                      style={{
                        background: "#D3D3D3",
                      }}
                    >
                      <BackwardOutlined />
                      Back
                    </Button>
                  </Form.Item>
                </div>

                <div style={{ display: "inline-block", marginLeft: "16px" }}>
                  <Form.Item label=" " colon={false}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="save-update-btn"
                      // style={{
                      //   background: "#f58029",
                      // }}
                    >
                      Save
                      <FormOutlined />
                    </Button>
                  </Form.Item>
                </div>
                <div style={{ display: "inline-block", marginLeft: "16px" }}>
                  <Form.Item label=" " colon={false}>
                    <Button
                      type="text"
                      htmlType="button"
                      style={{
                        background: "#D3D3D3",
                      }}
                    >
                      Reset
                      <RetweetOutlined />
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </div>
          </Form>
        </Card>
      </div>
    </WrapperComponent>
  );
};
export default CourseQuizAdd;
